__turbopack_context__.v({
  "fade-in": "InsuranceAdvanced-module-scss-module__gFdUzW__fade-in",
  "footer": "InsuranceAdvanced-module-scss-module__gFdUzW__footer",
  "form": "InsuranceAdvanced-module-scss-module__gFdUzW__form",
  "formGrid": "InsuranceAdvanced-module-scss-module__gFdUzW__formGrid",
  "no-transform": "InsuranceAdvanced-module-scss-module__gFdUzW__no-transform",
  "rotate": "InsuranceAdvanced-module-scss-module__gFdUzW__rotate",
});
